import { render, staticRenderFns } from "./Price_Setting.vue?vue&type=template&id=4ae2cce6&"
import script from "./Price_Setting.vue?vue&type=script&lang=js&"
export * from "./Price_Setting.vue?vue&type=script&lang=js&"
import style0 from "./Price_Setting.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports